import type { IAssistantPermissionChangedNotificationData } from "@frontend-shared/types";
import { ShieldHalf } from "lucide-react";
import { memo, useCallback } from "react";
import { Trans, useTranslation } from "react-i18next";

import { NotificationCardShell } from "../NotificationCardShell";

interface IAssistantPermissionChangedCardProps {
  uuid: string;
  data: IAssistantPermissionChangedNotificationData;
  createdAt: string;
  isRead: boolean;
  onViewAssistants: (projectUuid: string) => void;
}

const AssistantPermissionChangedCardComponent = ({
  uuid,
  data,
  createdAt,
  isRead,
  onViewAssistants,
}: IAssistantPermissionChangedCardProps): React.JSX.Element => {
  const { t } = useTranslation("notifications");

  const handleViewAssistants = useCallback(
    () => onViewAssistants(data.projectUuid),
    [onViewAssistants, data.projectUuid],
  );

  return (
    <NotificationCardShell
      uuid={uuid}
      variantTestId="assistant_permission_changed"
      createdAt={createdAt}
      isRead={isRead}
      icon={<ShieldHalf className="h-5 w-5 text-indigo-500" />}
      iconBgClassName="bg-indigo-500/10"
      ctaLabel={t("view_assistants")}
      onCtaClick={handleViewAssistants}
      body={
        <Trans
          ns="notifications"
          i18nKey="type.assistant_permission_changed.body"
          values={{
            ownerName: data.ownerName,
            assistantName: data.assistantName,
            permissionLevel: data.permissionLevel,
          }}
          components={{ b: <strong /> }}
        />
      }
    />
  );
};

export const AssistantPermissionChangedCard = memo(
  AssistantPermissionChangedCardComponent,
);
